// ── Shared devices cache (C1389) ──
//
// First web-side caller of GET /api/devices — the web app never queried this endpoint
// before (see ai/architecture/tt-api-devices.md). Used only to gate the task-detail panel's
// "Start in Task App" button: a device counts as "linked" when its project_ids includes the
// current project, meaning some machine has run Task App setup and bound it there.
//
// Same memoize-per-session discipline as lib/project.js's loadProject() — one fetch per page
// lifetime, fails open to [] so a devices hiccup only disables the button, never blocks the
// panel. No invalidation hook is needed: device↔project linking only changes via Task App
// setup on some other machine, not from anything this session can do.

import { api } from '../api.js';

let _cache = null; // Promise<Device[]> | null

// Fetches `GET /devices` — user-scoped, no project nesting (see tt-api-devices.md).
export function loadDevices() {
  if (!_cache) {
    _cache = api.get('/devices')
      .then(res => res.devices || [])
      .catch(() => []);
  }
  return _cache;
}

// True when some device of the signed-in user has `projectId` in its project_ids.
export async function hasLinkedDevice(projectId) {
  const devices = await loadDevices();
  const target = String(projectId);
  return devices.some(d => (d.project_ids || []).some(id => String(id) === target));
}
